"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var otherSpecify_exports = {};
__export(otherSpecify_exports, {
  isOtherSpecify: () => isOtherSpecify,
  otherSpecify: () => otherSpecify
});
module.exports = __toCommonJS(otherSpecify_exports);
var import_index = require("./index.js");
var import_guard = require("@cartographerio/guard");
function isOtherSpecify(isA) {
  return function(value) {
    return (0, import_guard.isObject)(value) && (0, import_guard.hasKey)(value, "selected", isA) && (0, import_guard.hasOptionalKey)(value, "other", (0, import_guard.isNullable)(import_guard.isString));
  };
}
function otherSpecify(options) {
  const {
    level = "info",
    requiredLevel = level,
    forbiddenLevel = level,
    label,
    basePath = [],
    thisPath = [...basePath, "other"],
    thatPath: otherPath = [...basePath, "selected"],
    test: otherTest,
    visible: _visible,
    help = "If you selected 'Other' above, please describe.",
    rows = 1
  } = options;
  const createField = (props) => rows === 1 ? (0, import_index.textField)(props) : (0, import_index.textArea)({ ...props, rows });
  const visible = _visible === "auto" ? (0, import_index.topoExpr)((env) => otherTest(env.get(otherPath))) : _visible;
  return createField({
    label,
    path: thisPath,
    visible,
    help: help ?? void 0,
    customRules: (0, import_index.requiredIff)({
      requiredLevel,
      forbiddenLevel,
      requiredMessage: "Please describe your selection.",
      forbiddenMessage: "Only enter a description if you selected 'Other' above.",
      enabled: visible,
      otherPath,
      otherTest
    })
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isOtherSpecify,
  otherSpecify
});
//# sourceMappingURL=otherSpecify.js.map
